<div>
    <!-- Sections Header -->
    <div class="sections-header">
        <div class="sections-title">
            <i class="fa-solid fa-sitemap"></i>
            <span>{{'sections' | translate}}</span>
        </div>
        <p-button (onClick)="openSectionModal(0)" 
                  label="{{'add' | translate}}" 
                  [outlined]="true">
        </p-button>
    </div>
    
    <!-- Sections Cards Grid -->
    <div class="grid mt-4" (click)="closeAllMenus()">
        @for(section of sections; track section.id; let i = $index){
        <div class="lg:col-4 md:col-6 col-12">
            <article class="section-card" [style.animation-delay]="(i * 0.1) + 's'">
                
                <!-- 3-Dot Menu (Top Left) -->
                <div class="section-menu-container" (click)="$event.stopPropagation()">
                    <button class="menu-dots-btn" (click)="toggleMenu($event, section.id || 0)">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                    </button>
                    @if(activeMenuId === section.id) {
                    <div class="menu-dropdown" (click)="$event.stopPropagation()">
                        <button class="menu-item menu-edit" (click)="openSectionModal(section.id || 0); closeMenu()">
                            <i class="fa-solid fa-pen-to-square"></i>
                            <span>{{'edit'|translate}}</span>
                        </button>
                        <button class="menu-item menu-delete" (click)="openDeleteSectionModal(section.id || 0); closeMenu()">
                            <i class="fa-regular fa-trash-can"></i>
                            <span>{{'delete'|translate}}</span>
                        </button>
                    </div>
                    }
                            </div>

                <!-- Card Header -->
                <div class="section-card-header">
                    <div class="section-name">
                        <i class="fa-solid fa-sitemap"></i>
                        {{section.name}}
                    </div>
                </div>
                
                <!-- Card Body -->
                <div class="section-card-body">
                    <div class="section-info-item">
                        <i class="fa-solid fa-user-tie info-icon"></i>
                        <div class="info-content">
                            <span class="info-label">{{'Manager' | translate}}</span>
                            <span class="info-value">
                        @if(section.in_charge_name){
                                    {{section.in_charge_name}}
                            }@else {
                                {{'no_section_head_assigned' | translate}}
                            }
                        </span>
                        </div>
                </div>
                </div>
            </article>
            </div>
            }

        <!-- Empty State -->
        @if(sections.length === 0) {
        <div class="col-12">
            <div class="empty-state">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M60 110C87.6142 110 110 87.6142 110 60C110 32.3858 87.6142 10 60 10C32.3858 10 10 32.3858 10 60C10 87.6142 32.3858 110 60 110Z" fill="#C91F3B" fill-opacity="0.1"/>
                    <path d="M30 60H90M60 30V90M45 45V75M75 45V75" stroke="#C91F3B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="60" cy="60" r="35" stroke="#C91F3B" stroke-width="3" fill="none"/>
                </svg>
                <h3>{{'no_sections_found' | translate}}</h3>
                <p>{{'click_add_button_to_create_section' | translate}}</p>
            </div>
        </div>
        }
    </div>
</div>

<!-- Add/Edit Section Modal -->
@if(isModalVisible)
{
<div class="modal-wrapper">
    <div class="g-overlay" (click)="closeDepartmentModal()"></div>
    <div class="g-modal">
        <div class="modal-header">
            <div class="modal-title">
                @if(dir=='rtl'){
                    {{selectedSection.id>0?'تعديل قسم':'إضافة قسم جديد'}}
                }@else{
                    {{selectedSection.id>0?'Edit Section':'Add New Section'}}
                }
            </div>
            <button class="close-btn" (click)="closeDepartmentModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <div class="modal-body">
            <form #sectionForm="ngForm" (ngSubmit)="submit()">
                <div class="form-control">
                    <label for="department" class="form-label">
                        <i class="fa-solid fa-building"></i>
                            {{'departments_offices' | translate}}
                    </label>
                    <p-dropdown #departmentId="ngModel" 
                                name="departmentId"
                                [(ngModel)]="selectedDepartmentId" 
                                [options]="departmentOptions" 
                                optionLabel="label"
                                optionValue="id" 
                                placeholder="{{'select_department' | translate}}"
                                required>
                    </p-dropdown>
                    @if((departmentId.invalid && !departmentId.pristine)||(isModalSubmitted&&departmentId.invalid)){
                    <small class="error-message">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        {{'field is required' | translate}}
                    </small>
                        }
                    </div>

                <div class="form-control">
                    <label for="name" class="form-label">
                        <i class="fa-solid fa-sitemap"></i>
                        {{'name' | translate}}
                    </label>
                    <input type="text" 
                           id="name" 
                           pInputText 
                           #name="ngModel"
                           [(ngModel)]="selectedSection.name" 
                           name="name" 
                           required
                           placeholder="{{'enter_section_name' | translate}}" />
                    @if((name.invalid && !name.pristine)||(isModalSubmitted&&name.invalid)){
                    <small class="error-message">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        {{'field is required' | translate}}
                    </small>
                    }
                </div>
                
                <div class="form-control">
                    <label for="in_charge" class="form-label">
                        <i class="fa-solid fa-user-tie"></i>
                        {{'Manager' | translate}}
                    </label>
                    <p-dropdown 
                        id="in_charge"
                        [(ngModel)]="selectedSection.in_charge_id" 
                        [options]="userOptions" 
                        optionLabel="label" 
                        optionValue="id"
                        name="in_charge_id"
                        [filter]="true"
                        filterBy="label"
                        [showClear]="true"
                        [placeholder]="dir === 'rtl' ? 'اختر المسئول' : 'Select Manager'"
                        filterPlaceholder="{{dir === 'rtl' ? 'بحث...' : 'Search...'}}"
                        emptyMessage="{{dir === 'rtl' ? 'لا توجد نتائج' : 'No results found'}}"
                        emptyFilterMessage="{{dir === 'rtl' ? 'لا توجد نتائج' : 'No results found'}}" />
                </div>
            </form>
        </div>
        
        <div class="modal-footer">
            <button type="button" class="cancel-btn" (click)="closeDepartmentModal()">
                <i class="fa-solid fa-xmark"></i>
                {{'cancel' | translate}}
            </button>
            <button type="submit" class="save-btn" (click)="submit()">
                <i class="fa-solid fa-check"></i>
                {{'save' | translate}}
            </button>
        </div>
    </div>
</div>
}

<!-- Delete Section Modal -->
@if(isDeleteSectionModalVisible){
<div class="modal-wrapper">
    <div class="g-overlay" (click)="closeDeleteModal()"></div>
    <div class="g-modal delete-modal">
        <div class="modal-header">
            <div class="modal-title">
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{'Organizational Unit Deletion Action'|translate}}
                <span class="section-name-highlight">( {{currentSectionDeletionPreview?.section?.name}} )</span>
            </div>
            <button class="close-btn" (click)="closeDeleteModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        
        <div class="modal-body">
            @if(!isEmployeeDeletable) {
            <div class="warning-section">
                <div class="warning-message">
                    <i class="fa-solid fa-circle-info"></i>
                    <p>{{'transfer_projects_before_delete' | translate}}</p>
                    </div>
                
                <form [formGroup]="unitProjectsForm" (ngSubmit)="onProjectTransferSubmit()">
                    <div class="transfer-projects-section">
                        <h4>{{'projects_to_transfer' | translate}}</h4>
                        @for(project of unitProjects; track project.id; let i = $index) {
                        <div class="project-transfer-item" [formGroupName]="i">
                            <div class="project-info">
                                <strong>{{project.name}}</strong>
                                <span>{{project.strategy_name}}</span>
                                </div>
                            <div class="transfer-controls">
                                <p-dropdown [formControlName]="'entity_in_charge_id'"
                                            [options]="project.entitiesInCharge"
                                            optionLabel="name"
                                            optionValue="key"
                                            placeholder="{{'select_unit' | translate}}">
                                </p-dropdown>
                                <p-dropdown [formControlName]="'executive_in_charge_id'"
                                            [options]="project.filteredInChargeExecutives"
                                            optionLabel="name"
                                            optionValue="id"
                                            placeholder="{{'select_executive' | translate}}">
                                </p-dropdown>
                            </div>
                        </div>
                        }
                    </div>
                    <button type="submit" class="submit-transfer-btn">
                        <i class="fa-solid fa-right-left"></i>
                        {{'transfer_projects' | translate}}
                    </button>
                </form>
                                </div>
            }
            
            @if(isEmployeeDeletable && employees.length > 0) {
            <div class="warning-section">
                <div class="warning-message">
                    <i class="fa-solid fa-circle-info"></i>
                    <p>{{'transfer_employees_before_delete' | translate}}</p>
                </div>

                <form [formGroup]="employeeForm" (ngSubmit)="onEmployeeTransferSubmit()">
                    <div class="transfer-employees-section">
                        <h4>{{'employees_to_transfer' | translate}}</h4>
                        @for(employee of employees; track employee.id; let i = $index) {
                        <div class="employee-transfer-item" [formGroupName]="i">
                            <div class="employee-info">
                                <strong>{{employee.name}}</strong>
                                <span>{{employee.username}}</span>
            </div>
                            <div class="transfer-controls">
                                <p-dropdown [formControlName]="'department_id'"
                                            [options]="employee.departments"
                                            optionLabel="name"
                                            optionValue="id"
                                            placeholder="{{'select_department' | translate}}">
                                </p-dropdown>
                                <p-dropdown [formControlName]="'section_id'"
                                            [options]="employee.filterdSections"
                                            optionLabel="name"
                                            optionValue="id"
                                            placeholder="{{'select_section' | translate}}">
                                </p-dropdown>
                                <p-dropdown [formControlName]="'role'"
                                            [options]="employee.roles"
                                            optionLabel="name"
                                            optionValue="value"
                                            placeholder="{{'select_role' | translate}}">
                                </p-dropdown>
                                </div>
                                </div>
                        }
                    </div>
                    <button type="submit" class="submit-transfer-btn">
                        <i class="fa-solid fa-right-left"></i>
                        {{'transfer_employees' | translate}}
                    </button>
                </form>
            </div>
            }
            
            @if(isEmployeeDeletable && employees.length === 0) {
            <div class="confirm-delete-section">
                <div class="delete-icon">
                    <i class="fa-solid fa-trash-can"></i>
                </div>
                <p class="confirm-message">{{'confirm_delete_section' | translate}}</p>
                <div class="action-buttons">
                    <button class="cancel-btn" (click)="closeDeleteModal()">
                        <i class="fa-solid fa-xmark"></i>
                        {{'cancel' | translate}}
                    </button>
                    <button class="delete-confirm-btn" (click)="confirmSectionDelete($event, currentSectionDeletionPreview?.section?.id)">
                        <i class="fa-solid fa-trash-can"></i>
                        {{'confirm_delete' | translate}}
                    </button>
                </div>
            </div>
            }
        </div>
    </div>
</div>
}

<p-confirmPopup></p-confirmPopup>
